export default __webpack_public_path__ + "static/experienceImg1-ee42d7442ad1c0b34c2e4d3ce52cc01b.png";